import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PACKAGE from '../../../../package.json';
import ApiGo from '../../../actions/ApiGo';
import comm_imgs from '../../../comm_imgs';
import comm_data from '../../../comm_data';
import ApiGo_TS from '../../../actions/ApiGo_TS';

const UpdateSetting = (props) => {
  const { t } = useTranslation();
  const [showWarning, setShowWarning] = useState(false);
  const [version, setVersion] = useState('');
  function toggleWarning() {
    setShowWarning(!showWarning);
  }
  const [timer, setTimer] = useState(100);
  // release note 下載
  const [downloadIntro, setDownloadIntro] = useState(false);
  const IntroBtmDiv = (
    <>
      <div
        className="download_RELEASE font-ml fx-ccc"
        onClick={() => {
          setDownloadIntro(true);
        }}>
        <div className="fx-d-r fx-cspar w-100">
          <div className="fx-cspar">
            <img src={comm_imgs.DB_INFO} />
          </div>
          <div className="margr-s fx-d-r fx-ccc">
            <div>{t("ADMIN.UPDATE.UPDATE_NOTES")}</div>
            <span className="margl-ss font-Bold font-m" style={{ color: '#008FD7' }}>
              GV{version}
            </span>
          </div>
        </div>
      </div>
    </>
  );
  useEffect(() => {
    if (downloadIntro) {
      window.open(`${comm_data.API_HOST}/static/release_notes.log`);
      setDownloadIntro(false);
    }
    return () => {
      setDownloadIntro(false);
    };
  }, [downloadIntro]);
  useEffect(() => {
    if (timer <= 0) {
      window.location.reload();
    }
    if (timer <= 11) {
      let _t = timer - 1;
      setTimeout(() => {
        setTimer(_t);
      }, [1000]);
    }
  }, [timer]);
  useEffect(() => {
    fetchVersionFromLog();
  }, []);
  const fetchVersionFromLog = async () => {
    try {
      const res = await ApiGo_TS.getVersion();
      setVersion(res.version);
    } catch (error) {
      console.error('Error fetching version:', error);
      setVersion('');
    }
  };
  return (
    <div className="fx-d-c font-m bgC-white w-80 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
      {showWarning ? <Warning hide={toggleWarning} startCountDown={setTimer} mos={props.mos} /> : ''}
      <div className="fx-d-r fx-cspbt font-l margl-xs h-100 margt-xxs w-90">
        <div>{t("ADMIN.UPDATE.SYSTEM_UPDATE")}</div>
        <div className="w-40 fx-d-r fx-fec">{IntroBtmDiv}</div>
      </div>
      <div className=" margl-xs">
        {t("ADMIN.UPDATE.CURRENT_VERSION")}
        <span className="font-Bold" style={{ color: '#008FD7' }}>
          GV{version}
        </span>
      </div>
      <div className="font-ml margl-xs margt-s ">{t("ADMIN.UPDATE.NOTE_ITEMS.TITLE")}</div>
      <div className="font-m margl-xs w-90 fx-d-c">
        <div className="h-85 fx-d-c w-100">
          <div className="margt-xs fx-d-r fx-fsc">
            {t("ADMIN.UPDATE.NOTE_ITEMS.ITEM1")}
            <span className="font-Bold" style={{ color: '#008FD7' }}>
              {t("ADMIN.UPDATE.UPDATE_FILE")}
            </span>
            {t("ADMIN.UPDATE.NOTE_ITEMS.ITEM1_CONT")}
          </div>
          <div className="margt-xs fx-d-r fx-fsc">{t("ADMIN.UPDATE.NOTE_ITEMS.ITEM2")}</div>
          <div className="margt-xs fx-d-r fx-fsc">{t("ADMIN.UPDATE.NOTE_ITEMS.ITEM3")}</div>
        </div>
      </div>
      <div className="fx-d-r margl-xs margt-s font-ml w-70 pad-15 t fx-cspbt">
        <div
          className="br-10 bgC-light fx-ccc pad-15 l r shadow-xs"
          onClick={() => {
            toggleWarning(true);
          }}>
          {t("ADMIN.UPDATE.UPDATE_BUTTON")}
        </div>
      </div>
    </div>
  );
};
export default UpdateSetting;

function Warning(props) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [inputValue, setInputValue] = useState(false);
  const [placeholder, setPlaceholder] = useState(t("ADMIN.UPDATE.ENTER_PASSWORD"));
  const Account = localStorage.getItem('currentAccount');
  const DEVICE = JSON.parse(localStorage.getItem('Device_OS'));
  const mos = props.mos;
  const [apiState, setApiState] = useState(0);
  function startUpdate() {
    if (password === '') {
      setInputValue(true);
      return;
    }
    ApiGo.start_update_service(Account, password, DEVICE.os, DEVICE.type)
      .then(() => {
        setApiState(1);
        mos.sendPayload('upgrade_gv_system/startUpgrade', 'start_update_service');
      })
      .catch(() => {
        setInputValue(true);
        setPassword('');
        setPlaceholder(t("ADMIN.UPDATE.PASSWORD_ERROR"));
      });
  }

  return (
    <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black">
      <div className="layout-input font-ml fx-d-c pad-30 l r" onClick={(e) => e.stopPropagation()}>
        {apiState === 0 ? (
          <>
            <div className="h-35 font-l fx-d-r fx-fse">{t("ADMIN.UPDATE.CONFIRM_UPDATE")}</div>
            <div className="h-40 fx-d-r pad-5 fx-fsc">
              <input
                placeholder={placeholder}
                className={(inputValue ? 'border-red' : 'border') + ' br-5 w-80 pad-10 l'}
                type="password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                value={password}
              />
            </div>
            <div className="wrap-personal-btn w-100 h-25 fx-fec">
              <div className="h-100 w-60 fx-d-r">
                <div className="fx-ccc w-50 btn_type" onClick={startUpdate}>
                  {t('GLOBAL.CONFIRM')}
                </div>
                <div className="fx-ccc w-50 btn_type" onClick={props.hide}>
                  {t('GLOBAL.CANCEL')}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="h-100 fx-d-c fx-ccc">
            <div className="font-l fx-d-r fx-cfs">{t("ADMIN.UPDATE.VERIFICATION_PASSED")}</div>
            <div className="font-m">{t("ADMIN.UPDATE.BROWSER_CONFIRM")}</div>
          </div>
        )}
      </div>
    </div>
  );
}